import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    addSelfstake: 'Add Selfstake',
    edit: 'Edit',
  },
};
